module.exports = __webpack_public_path__ + "static/hero-vulnerable-customers-2b2c59e2acb2079ac368231d7548e3e4.webp";